export default "__VITE_ASSET__D_K0FoME__"